<template>
  <help-info-wrapper
    :info.sync="helpData"
    :service-name="serviceName"
    class="warp"
  >
    <v-card flat>
      <custom-tabs
        v-model="tabs"
        grow
        :class="{ 'hide-tab-headers': !showTabs }"
      >
        <template v-slot:staticTabs v-if="showTabs">
          <v-tab>
            <div class="cornel-left" />
            <div class="cornel-right" />
            <v-icon small left class="px-1">mdi-palette-advanced</v-icon>
            {{ $t("image") }}
            <help-info
              :element-name="`${serviceName}-${componentName}-photo-logo-tab`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('gif_tab')"
            />
          </v-tab>

          <v-tab v-if="valueComputed?.hasGif">
            <div class="cornel-left" />
            <div class="cornel-right" />
            <v-icon small left class="px-1">mdi-movie</v-icon>
            {{ $t("gif_tab") }}
            <help-info
              :element-name="`${serviceName}-${componentName}-photo-logo-tab`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('gif_tab')"
            />
          </v-tab>

          <v-tab v-if="valueComputed?.hasGame">
            <div class="cornel-left" />
            <div class="cornel-right" />
            <v-icon small left class="px-1">mdi-gamepad-variant</v-icon>
            {{ $t("game_tab") }}
            <help-info
              :element-name="`${serviceName}-${componentName}-gallery-image-tab`"
              :service-name="serviceName"
              :help-data="helpData"
              class="buttoninfo"
              :label="$t('game_tab')"
            />
          </v-tab>
        </template>

        <template v-slot:middle v-if="showTabs">
          <div class="pt-4" />
        </template>

        <template v-slot:staticItems>
          <v-tab-item>
            <v-card flat class="pa-4 w-100">
              <v-card-title class="py-0">{{
                $t("welcome_image_upload")
              }}</v-card-title>
              <pic-selector
                :edit-img="false"
                :edit-name="false"
                :field.sync="valueComputed.welcome"
                :default-cat-name="$t('default_welcome')"
                one-pic
                single
              />
              <v-col class="pa-2" cols="12">
                <label for="transition">{{ $t("loading_animation") }}</label>
                <div class="rowinfo">
                  <v-select
                    id="transition"
                    v-model="transition"
                    :items="transitionItems"
                    :menu-props="{ offsetY: true }"
                    dense
                    outlined
                  />
                  <help-info
                    :element-name="`${serviceName}-${componentName}-transition`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('loading_animation')"
                  />
                </div>
              </v-col>
              <v-col class="pa-2" cols="12">
                <div class="rowinfo">
                  <v-btn
                    color="indigo"
                    class="contentinfo"
                    outlined
                    small
                    text
                    @click="showWelcome = !showWelcome"
                  >
                    {{ $t("preview_welcome_page") }}
                  </v-btn>
                  <help-info
                    :element-name="`${serviceName}-${componentName}-transition`"
                    :service-name="serviceName"
                    :help-data="helpData"
                    class="buttoninfo"
                    :label="$t('preview_welcome_page')"
                  />
                </div>
              </v-col>
            </v-card>
          </v-tab-item>

          <v-tab-item v-if="valueComputed?.hasGif">
            <v-row no-gutters>
              <v-col class="pa-4" cols="12">
                <v-card-title class="py-0 mb-3">{{
                  $t("welcome_gif_upload")
                }}</v-card-title>

                <gif-selector
                  v-model="previewerGallery"
                  :edit-img="false"
                  :multipleFile="false"
                  :inputType="'image/gif'"
                  :edit-name="false"
                  :field.sync="valueComputed.previewerQr.previewer.gif"
                  :default-cat-name="$t('default_welcome')"
                  one-pic
                  single
                />
              </v-col>

              <v-col class="pa-4" cols="12">
                <label class="d-block mb-2">{{
                  $t("loading_animation")
                }}</label>
                <v-select
                  v-model="valueComputed.previewerQr.transition"
                  :items="transitionItems"
                  :menu-props="{ offsetY: true }"
                  dense
                  outlined
                  hide-details
                />
              </v-col>

              <v-col class="pa-4" cols="12">
                <label class="d-block mb-2">گوشه گرد تصویر گیف (پیکسل)</label>
                <v-text-field
                  v-model="gifBorderRadius"
                  :value="gifBorderRadius"
                  type="number"
                  min="0"
                  max="100"
                  dense
                  outlined
                  hide-details
                  placeholder="مقدار گوشه گرد را وارد کنید"
                  @input="updateGifBorderRadius"
                />
              </v-col>

              <v-col class="pa-4 w-100" cols="12">
                <v-btn
                  block
                  color="indigo"
                  outlined
                  small
                  @click="showPreviewer = !showPreviewer"
                >
                  {{
                    showPreviewer
                      ? $t("hide_previewer")
                      : $t("preview_welcome_page")
                  }}
                </v-btn>
              </v-col>
            </v-row>
          </v-tab-item>

          <v-tab-item v-if="valueComputed?.hasGame">
            <v-card flat class="pa-4">
              <game-selector
                v-model="valueComputed.previewerQr.previewer.game"
                @edit="openGameEditor"
                @preview="handleGamePreview"
              />

              <custom-popup
                v-model="showGameEditor"
                :cons="{
                  title: $t('edit_game_settings'),
                  icon: 'mdi-gamepad-variant',
                }"
                max-width="1200"
                persistent
                scrollable
              >
                <public-game-editor
                  v-if="valueComputed?.previewerQr"
                  v-model="valueComputed.previewerQr"
                  @input="onGameConfigUpdate"
                />

                <template v-slot:actions>
                  <v-spacer></v-spacer>
                  <v-btn color="grey" text @click="showGameEditor = false">
                    {{ $t("cancel") }}
                  </v-btn>
                  <v-btn color="primary" @click="saveAndCloseEditor">
                    {{ $t("save_and_close") }}
                  </v-btn>
                </template>
              </custom-popup>
            </v-card>
          </v-tab-item>
        </template>
      </custom-tabs>
    </v-card>
  </help-info-wrapper>
</template>

<script>
import { Bus } from "@/main";
import picSelector from "../../../components/UploadCenter/picSelector.vue";
import gifSelector from "@/view/components/UploadCenter/gifSelector";
import gameSelector from "@/view/components/UploadCenter/gameSelector";
import PublicGameEditor from "@/view/components/game/publicGame/PublicGameEditor.vue";

export default {
  name: "previewerQr",

  components: {
    gifSelector,
    gameSelector,
    PublicGameEditor,
    picSelector,
  },

  props: {
    value: {
      type: Object,
      default: () => ({}),
    },
  },

  data() {
    return {
      showWelcome: false,
      welcomeGallery: [{ name: "", images: [] }],
      hasWelcome: false,
      welcomeImg: null,
      helpData: [],
      serviceName: "Qrland",
      componentName: "previewerQr",
      showGameEditor: false,
      tabs: 0, // Default to first tab (photo)
      showPreviewer: false,
      transition: "scale",
      previewerGallery: [{ name: "", images: [] }],
      gifBorderRadius: 0, // New field for GIF border radius
    };
  },

  computed: {
    showTabs() {
      return (
        (this.value?.hasGif || this.value?.hasGame) &&
        [
          "qr.product.productPro",
          "qr.name.productPro",
          "qr.name.id.productPro",
          'qr.create.productPro',
          'qr.create.productProModel',

        ].includes(this.$route.name)
      );
    },

    transitionItems() {
      return [
        { text: this.$t("animation_scale"), value: "scale" },
        { text: this.$t("animation_slide_x"), value: "slideX" },
        { text: this.$t("animation_slide_y"), value: "slideY" },
        { text: this.$t("animation_fade"), value: "fade" },
      ];
    },

    valueComputed: {
      get() {
        return this.value || {};
      },
      set(val) {
        this.$emit("input", val);
      },
    },
    previewerQrSafe() {
      if (!this.valueComputed?.previewerQr) {
        this.$set(this.valueComputed, "previewerQr", {});
      }
      return this.valueComputed?.previewerQr;
    },
  },

  watch: {
    welcomeGallery: {
      deep: true,

      handler(val) {
        if (val[0] && val[0].images && val[0].images.length > 0) {
          this.welcomeImg = "";
          this.valueComputed.welcome = "";

          this.$nextTick(() => {
            this.valueComputed.welcome = val[0].images[0].url;
          });
        } else {
          this.welcomeImg = "";
          this.valueComputed.welcome = null;
        }
      },
    },
    "valueComputed.transition"(val) {
      this.transition = val || "scale";
    },

    previewerGallery: {
      deep: true,
      handler(val) {
        if (val?.[0]?.images?.length > 0) {
          this.valueComputed.previewerQr.previewer.gif = val[0].images[0].url;
        } else {
          this.valueComputed.previewerQr.previewer.gif = null;
        }
      },
    },

    showPreviewer(val) {
      Bus.$emit("showPreviewer", val);
    },
  },

  mounted() {
    this.$root.$on("clearDefaultData", this.clearDefaults);

    // Restore active tab based on saved data
    this.restoreActiveTab();

    if (this.value?.previewerQr?.previewer?.gif) {
      this.previewerGallery = [
        {
          name: "گیف خوش‌آمد",
          images: [{ url: this.value.previewerQr.previewer.gif }],
        },
      ];
    }

    this.transition = this.value?.previewerQr?.transition || "scale";

    // Restore GIF border radius if it exists
    if (this.value?.previewerQr?.gifBorderRadius !== undefined) {
      this.gifBorderRadius = this.value.previewerQr.gifBorderRadius;
    }
  },

  methods: {
    // Method to restore the active tab based on saved data
    restoreActiveTab() {
      if (!this.showTabs) {
        this.tabs = 0;
        return;
      }

      // Check which content is configured and set the corresponding tab
      if (this.value?.welcome) {
        // Photo tab is active
        this.tabs = 0;
      } else if (
        this.value?.hasGif &&
        this.value?.previewerQr?.previewer?.gif
      ) {
        // GIF tab is active
        this.tabs = 1;
      } else if (
        this.value?.hasGame &&
        this.value?.previewerQr?.previewer?.game?.type
      ) {
        this.tabs = this.value?.hasGif ? 2 : 1;
      }
    },

    updateGifBorderRadius(value) {
      // Update the value in the data model
      this.gifBorderRadius = parseInt(value) || 0;

      // Store it in the previewerQr object
      if (!this.valueComputed.previewerQr) {
        this.$set(this.valueComputed, "previewerQr", {});
      }
      this.valueComputed.previewerQr.gifBorderRadius = this.gifBorderRadius;
    },

    openGameEditor() {
      this.showGameEditor = true;
    },

    onGameConfigUpdate(newValue) {
      this.$forceUpdate();
    },

    saveAndCloseEditor() {
      this.showGameEditor = false;
      this.$toast.success(this.$t("game_settings_saved"));
    },

    handleGamePreview() {
      if (!this.valueComputed?.previewerQr?.previewer?.game?.config?.type) {
        this.$toast.warning("ابتدا نوع بازی و تنظیمات را ذخیره کنید");
        return;
      }
      if (!this.valueComputed?.previewerQr?.previewer?.game?.config) {
        this.$toast.warning(this.$t("no_game_configured"));
        return;
      }

      Bus.$emit("preview-game-in-mobile", {
        game: this.valueComputed.previewer.game,
      });

      this.$emit(
        "update:previewGame",
        this.valueComputed.previewerQr.previewer.game,
      );
    },

    clearDefaults() {
      this.valueComputed.previewerQr.previewer = {
        gif: null,
        game: null,
        transition: "scale",
      };
      this.previewerGallery = [{ name: "", images: [] }];
      this.transition = "scale";
      this.$forceUpdate();
    },
  },
};
</script>

<style scoped>
::v-deep .hide-tab-headers .v-tabs-bar {
  display: none !important;
}

.warp {
  /* min-height: 400px; */
}
</style>
